
import React from 'react';

import { Navigate } from 'react-router-dom'
import { useMiddlewareContext } from '../../middleware';

const useAuth = () => {
    // const { token } = useMiddlewareContext() // when use token from middleware get issue when login
    const token = localStorage.getItem('token');
    // console.log('token', token)
    if (token) {
        return true
    } else {
        return false
    }
    // return setTimeout(() => {
    //     if (token) {
    //         return true
    //     } else {
    //         return false
    //     }
    // }, 1000 * 10)

}
const ProtectedRoutes = ({ children }) => {
    const auth = useAuth()

    return auth ? <>{children}</> : <Navigate to="/sign_in" />
}

export default ProtectedRoutes;